export default __webpack_public_path__ + "2d61b0811503d77224ee3cfa93bb4681.ogg";